import "./MyPortfolio.scss";
import { Link } from "react-router-dom";
import PortfolioCard from "../PortfolioCard/PortfolioCard";
import { _baseImageUrl } from "../../service/constants";

const MyPortfolio = ({ portfolioData, cardsToWatch = "all" }) => {
  const generateRandomValue = () => {
    const randomX = Math.random() < 0.5 
      ? Math.random() * 0.3 // Левый край (0% - 30%)
      : Math.random() * 0.3 + 0.7; // Правый край (70% - 100%)
    return {
      randomX,
      randomDuration: Math.random() * 5,
      randomDelay: Math.random(),
    };
  };

  console.log(portfolioData)
  

  const characters = ['0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1', '0', '1'];

  if(!portfolioData) return null
  let portfolioDataPreview
  if(cardsToWatch === "all"){
    portfolioDataPreview = portfolioData
  }else{
    portfolioDataPreview = portfolioData.slice(0, cardsToWatch )
  }
  return (
    <section id="my-portfolio" className="my-portfolio" style={{ padding: cardsToWatch === "all" ? "0px" : "100px 0" }}>
      {cardsToWatch === "all" ? null : <h2>My <span>Portfolio</span></h2>}

      <div className="portfolio__items row">
        {
          portfolioDataPreview.map(el => <PortfolioCard image={_baseImageUrl + el.image.path} title={el.title} path={`/portfolio/${el.link}`} descr={el.descrCard}/>)
        }
 
      </div>

      {cardsToWatch === "all" ? null : <Link className="portfolio__show-btn" to="/portfolio/">Show more</Link> }

      {/* Контейнер для падающих символов */}
      <div className="falling-letters">
        {characters.map((char, index) => {
          const { randomX, randomDuration, randomDelay } = generateRandomValue();
          return (
            <span
              key={index}
              className="falling-letter"
              style={{
                '--random-x': randomX,
                '--random-duration': randomDuration,
                '--random-delay': randomDelay,
              }}
            >
              {char}
            </span>
          );
        })}
      </div>
    </section>
  )
}

export default MyPortfolio





